import { useEffect, useState, useMemo } from "react";
import { useQuery } from "@tanstack/react-query";
import { getClientId } from "./clientId";
import { fetchClusters } from "./api";

const SEEN_KEY = "alphaapeing_cluster_seen";

export const getClusterSeen = () => {
  try { return new Set(JSON.parse(localStorage.getItem(SEEN_KEY) || "[]")); } catch { return new Set(); }
};

export const markClustersSeen = (mints) => {
  localStorage.setItem(SEEN_KEY, JSON.stringify(mints || []));
  window.dispatchEvent(new Event("cluster-seen-updated"));
};

export const useClusterAlerts = () => {
  const clientId = getClientId();
  const q = useQuery({ queryKey: ["clusters", clientId], queryFn: () => fetchClusters(clientId), refetchInterval: 30000 });
  const mints = useMemo(() => (q.data?.clusters || []).map((c) => c.tokenMint), [q.data]);

  const [seen, setSeen] = useState(getClusterSeen);
  useEffect(() => {
    const h = () => setSeen(getClusterSeen());
    window.addEventListener("cluster-seen-updated", h);
    return () => window.removeEventListener("cluster-seen-updated", h);
  }, []);

  const newCount = mints.filter((m) => !seen.has(m)).length;
  return { newCount, mints };
};
